var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"k4dashboard"}},[_c('layout-error-boundary',{staticClass:"fill-wh",attrs:{"on-error":_vm.handleAuthError}},[(_vm.layout)?_c(_vm.layout,{tag:"component"},[_c('router-view')],1):_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }